// 白、黒などの基本色はここに定義する
const colors = {
  white: '#fff',
  black: '#2b2b2b',
};

// ラウンジ、スクエア等のテーマカラーはここに定義する
const themeColors = {
  default: colors.white,
  lounge: '#68d391',
  square: '#FFD43A',
  knowledge: '#f09736',
  working: '#53c4f0',
};

export const mixins = {
  colors,
  themeColors,
};
